export enum PaymentPlatform {
  MercadoPago = 'mp',
  PayPal = 'paypal',
}

export enum PaymentType {
  BuyPlan = 'plan',
  Order = 'order',
  CustomerBalance = 'c_balance',
  Tip = 'tip',
  ClubTopup = 'club_topup',
  ReservationDeposit = 'rsv_deposit',
}

export enum PaymentStatus {
  Awaiting = 'await',
  Paid = 'paid',
  Declined = 'declined',
  Reimbursed = 'reimbursed',
  Unknown = 'unknown',
}
